import React, { useEffect, useState } from "react";
import Input from "../../../components/input";
import FIlterSelect from "../../../components/filter-select";
import Table from "../../../components/table";
import Button from "../../../components/button";
import { Plus } from "lucide-react";
import AddOrderDialog from "../../../components/orders";
import { I_Customer } from "../types";
import { I_ProductData } from "../../inventory/types";
import useRequest from "../../../components/hooks/use-request";
import { useNavigate } from "react-router-dom";
import { formatCurrency, getStatusColor, getStatusTextColor } from "../../../utilz/function";

interface OrderData {
    _id: string;
    orderId: string;
    source: string;
    totalAmount: number;
    createdAt: string;
    status: string;
    paymentStatus: string;
    
}

interface OrderHistoryProps {
    data: OrderData[];
    customers: any;
    selectedStatus?: string;
}

const OrderHistory: React.FC<OrderHistoryProps> = ({
    data,
    customers,
    selectedStatus
}) => {
    console.log(data, "data in order history");
    
    const [filteredData, setFilteredData] = useState<OrderData[]>([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [selectedType, setSelectedType] = useState("");
    const [customer, setCustomer] = useState<I_Customer[]>([]);
    const [ordersModal, setOrdersModal] = useState(false);
    const [product, setProduct] = useState<I_ProductData[]>([]);
    const userToken = localStorage.getItem("token");
    const navigate = useNavigate()

    

    const { makeRequest: getCustomers } = useRequest("/customers", "GET", {
        Authorization: `Bearer ${userToken}`,
    });

    const { makeRequest: getProducts } = useRequest("/inventory", "GET", {
        Authorization: `Bearer ${userToken}`,
    });

    const columns = [
        {header: "Order ID", accessor: "orderId"},
        {header: "Source", accessor: "source"},
        {header: "Amount", accessor: "totalAmount"},
        {header: "Order Date", accessor: "createdAt"},
        {header: "Status", accessor: "status"},
        {header: "Payment Status", accessor: "paymentStatus"},
    ];



    useEffect(() => {
        const filtered = data?.filter((order) => {
            const statusMatch = !selectedStatus || order?.status === selectedStatus;

            const searchMatch =
            !searchQuery ||
            order?.orderId
                ?.toLowerCase()
                .includes(searchQuery?.toLowerCase());
            const orderMatch = !selectedType || order?.status === selectedType;

            return statusMatch && searchMatch && orderMatch;
        });
        setFilteredData(filtered);
    }, [data, selectedStatus, searchQuery, selectedType]);

  

    const combinedData = filteredData?.map((order) => ({
        ...order,
        orderId: (
          <div>
            <div>{order?.orderId || "N/A"}</div>
          </div>
        ),
        source: (
            <div>
                <span className="p-2 capitalize">{order?.source || "N/A"}</span>
            </div>
        ),
        paymentStatus: (
          <div>
            <span
              style={{
                color: getStatusTextColor(order?.paymentStatus),
                backgroundColor: getStatusColor(order?.paymentStatus),
              }}
              className="p-2"
            >
              {order?.paymentStatus || "N/A"}
            </span>
          </div>
        ),
       
        totalAmount: (
          <div>
            <div>
              {formatCurrency( order?.totalAmount, "NGN", "symbol") || "N/A"}
            </div>
          </div>
        ),
        status: (
          <div>
            <div>
              {order?.status}
            </div>
          </div>
        ),
      }));


    

   

    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchQuery(e.target.value);
    };

    const handleOrderFilterChange = (selectedValue: string) => {
        setSelectedType(selectedValue);
    };

    function closeOrderModal() {
        setOrdersModal(false);
    }

    function openOrderModal() {
        setOrdersModal(true);
    }

    useEffect(() => {
        const fetchCustomers = async () => {
            const [response] = await getCustomers();
            if (response.status) {
                setCustomer(response.data?.customers?.docs);
            }
        };
        fetchCustomers();
    }, []);

    useEffect(() => {
        const fetchProducts = async () => {
            const [response] = await getProducts();
            if (response.status) {
                setProduct(response.data?.inventory?.docs);
            }
        };
        fetchProducts();
    }, []);

    return ( 
        <div className="py-3 bg-white rounded-3xl shadow border border-[#C9C9C9] mt-10 pt-5">
            <div className="my-5 mx-20">
                <div className="flex lg:grid lg:grid-cols-3 gap-4 overflow-x-auto scrollbar-hide lg:overflow-visible whitespace-nowrap">
                    <section className="bg-white border border-[#C9C9C9] rounded-3xl p-4 flex flex-col justify-between">
                    <p className="font-bold text-[14px] text-[#475467]">
                    Total Orders
                        <button type="button"></button>
                    </p>
                    <h1 className="text-[#2B2B2B] text-[36px] font-extrabold">
                        {data?.length || 0}
                    </h1>
                    </section>

                    {/* Orders Card */}
                    <section className="bg-white border border-[#C9C9C9] rounded-3xl p-4 flex flex-col justify-between">
                        <p className="font-bold text-[14px] text-[#475467]">
                            Total Spent
                            
                        </p>
                    
                        <h1 className="text-[#F59E0B] text-lg font-semibold">
                           {data?.reduce((total, item) => total + (item.totalAmount || 0), 0).toLocaleString('en-US', {
                                style: 'currency',
                                currency: 'NGN'
                            })}
                        </h1>
                    
                    </section>

                   

                    <section className="bg-white border border-[#C9C9C9] rounded-3xl p-4 flex flex-col justify-between">
                    <p className="font-bold text-[14px] text-[#475467]">
                    Ongoing Orders
                        <button type="button"></button>
                    </p>
                    <h1 className="text-[#9AC12A] text-[36px] font-extrabold">
                        {data?.filter(order => order.status !== 'delivered').length || 0}
                    </h1>
                    </section>
                </div>
            </div>
            <div className="md:flex justify-between px-5">
                <p className="text-[20px] font-bold">Orders</p>
                <div className="md:flex gap-2 items-center md:mt-0 mt-2">
                    <Input
                        name="search"
                        value={searchQuery}
                        onChange={handleSearchChange}
                        className="w-full"
                        placeholder="Search by name or email"
                        icon="searchIcon"
                    />

                    <FIlterSelect
                        name="status"
                        options={[
                            { value: "processing", label: "Processing" },
                            { value: "delivered", label: "Delivered" },
                            { value: "outForDelivery", label: "Dispatched" },
                        ]}
                        className="mt-2 md:-mt-2 w-full md:w-[50%]"
                        icon="filterIcon"
                        onChange={handleOrderFilterChange}
                        value={selectedType}
                    />
                </div>
            </div>

           

            {combinedData?.length > 0 ? (
                <Table
                    columns={columns}
                    data={combinedData}
                    selectedUserId={null}
                />
            ) : (
                <div className="opacity-80 mt-10 font-bold flex flex-col items-center gap-5 mx-auto">
                    This customer currently does not have any orders

                    {/* Fixed the logical condition - use OR instead of AND */}
                    {customers?.approvalStatus === "approved"  && (
                        <Button
                            size="lg"
                            variant="primary"
                            type="button"
                            className="font-normal md:mt-0 mt-6 w-fit"
                            onClick={openOrderModal}
                        >
                            <Plus />
                            Create Sales Order
                        </Button>
                    )}
                </div>
            )}

            <AddOrderDialog
                isVisible={ordersModal}
                onClose={closeOrderModal}
                customers={customer}
                product={product}
            />
        </div>
    );
};

export default OrderHistory;